import React from 'react';
import ImgBanner1 from '../../../assets/images/img-banner1.png';
import ContactZalo from 'components/atoms/ContactZalo';
interface IBannerProps {
  imgSrc: string;
  title: string;
}
const Banner = (props: IBannerProps) => {
  return (
    <div className="relative">
      <img
        src={props.imgSrc}
        alt="banner"
        className="w-full h-[442px] xl:h-screen max-h-screen object-cover"
      />
      <div className="text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 min-w-[375px]">
        <div className="flex flex-col gap-y-2 text-center items-center">
          <p className="text-base font-semibold leading-[22px]">-2023-</p>
          <h3 className="font-bold text-[40px] xl:leading-[84px] xl:text-[84px] md:text-[60px] font-dancing-script text-center">
            {props.title.split('-')[0]}
          </h3>
          <h3 className="font-bold text-[40px] xl:leading-[84px] xl:text-[84px] md:text-[60px] font-dancing-script text-center">
            {props.title.split('-')[1]}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Banner;
